module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-main",
    attrs: {
      "id": "pageMainH"
    }
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "type": "password"
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "container",
    class: {
      'is-min': _vm.collapsed, 'min-page': _vm.ismin
    }
  }, [_c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.meta.isLogin != true),
      expression: "$route.meta.isLogin != true"
    }],
    staticClass: "top-menu",
    class: _vm.$route.meta.isIndex == true ? 'index page-home' : ''
  }, [_c('div', {
    staticClass: "logo xieconet-logo"
  }, [_c('a', {
    class: _vm.showLogin ? '' : 'center',
    on: {
      "click": _vm.backHome
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getLogoUrl
    }
  })])]), _vm._v(" "), (false) ? _c('ul', {
    staticClass: "mobileLangu"
  }, [(_vm.thisLang == 'en') ? _c('li', [_c('span', {
    staticClass: "custom-item lan"
  }, [_c('span', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.cut_lan('cn')
      }
    }
  }, [_c('span', {
    staticClass: "border-set langu"
  }, [_c('i', {
    staticClass: "iconfont icon-chinese"
  }), _vm._v("\n                  中文\n                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.thisLang == 'cn') ? _c('li', [_c('span', {
    staticClass: "custom-item lan"
  }, [_c('span', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.cut_lan('en')
      }
    }
  }, [_c('span', {
    staticClass: "border-set langu"
  }, [_c('i', {
    staticClass: "iconfont icon-english"
  }), _vm._v("English")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "mobile-nav-btn",
    on: {
      "click": _vm.showMobileNav
    }
  }, [_c('i', {
    class: _vm.mobileNav ? 'el-icon-close' : 'el-icon-menu'
  })]), _vm._v(" "), _c('div', {
    staticClass: "responsive-nav",
    class: {
      'close': _vm.mobileNav
    }
  }, [(false) ? _c('div', {
    staticClass: "menu-tab"
  }, [_c('el-menu', {
    ref: "topNav",
    staticClass: "el-menu--dark",
    class: _vm.$route.meta.isIndex == true ? 'index' : '',
    attrs: {
      "default-active": _vm.defaultIndex,
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    class: _vm.$route.meta.isIndex == true ? 'index' : '',
    attrs: {
      "index": "search_company"
    },
    on: {
      "click": function($event) {
        _vm.searchRoute(0)
      }
    }
  }, [_c('span', {
    staticClass: "menu-item",
    class: _vm.$route.meta.isIndex == true ? 'index' : ''
  }, [_vm._v(_vm._s(_vm.$t('SEARCH_CMP')))])]), _vm._v(" "), _c('el-menu-item', {
    class: _vm.$route.meta.isIndex == true ? 'index' : '',
    attrs: {
      "index": "search_person"
    },
    on: {
      "click": function($event) {
        _vm.searchRoute(1)
      }
    }
  }, [_c('span', {
    staticClass: "menu-item",
    class: _vm.$route.meta.isIndex == true ? 'index' : ''
  }, [_vm._v(_vm._s(_vm.$t('SEARCH_CCT')))])]), _vm._v(" "), _c('el-menu-item', {
    class: _vm.$route.meta.isIndex == true ? 'index' : '',
    attrs: {
      "index": "user_company"
    },
    on: {
      "click": _vm.checkLogin
    }
  }, [_c('span', {
    staticClass: "menu-item",
    class: _vm.$route.meta.isIndex == true ? 'index' : ''
  }, [_vm._v(_vm._s(_vm.$t('MY_COMPANY_AND_PERSON')))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-user"
  }, [_c('ul', [(!_vm.channelId) ? _c('li', [_c('span', {
    staticClass: "custom-item",
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/package'
        })
      }
    }
  }, [_c('span', {
    staticClass: "menu-item",
    class: {
      'index': _vm.$route.meta.isIndex == true ? true : false,
        'is-active': _vm.$route.meta.menuIndex == 'package' ? true : false
    }
  }, [_c('span', {
    staticClass: "border-set high-light"
  }, [_c('i', {
    staticClass: "iconfont icon-huiyuanfuwu",
    staticStyle: {
      "font-size": "12px"
    }
  }), _vm._v("\n                        " + _vm._s(_vm.$t('_D6D6566556C3D365')) + "\n                      ")])])])]) : _vm._e(), _vm._v(" "), (false && !_vm.channelId && !_vm.is_cert) ? _c('li', [_c('span', {
    staticClass: "custom-item",
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/member/company-circle'
        })
      }
    }
  }, [_c('span', {
    staticClass: "menu-item",
    class: {
      'index': _vm.$route.meta.isIndex == true ? true : false,
        'is-active high': _vm.$route.meta.menuIndex == 'company-circle' ? true : false
    }
  }, [_c('span', {
    staticClass: "border-set high-light"
  }, [_c('i', {
    staticClass: "iconfont icon-enterprise-dentify",
    staticStyle: {
      "font-size": "12px"
    }
  }), _vm._v("\n                       " + _vm._s(_vm.$t('_7F28764B786320F9')) + "\n                      ")])])])]) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin && _vm.$route.meta.isLogin != true),
      expression: "!isLogin && $route.meta.isLogin != true"
    }],
    style: (_vm.showLogin ? '' : 'margin-right: 67px;')
  }, [_c('span', {
    staticClass: "custom-item",
    on: {
      "click": function($event) {
        _vm.login(1)
      }
    }
  }, [_c('span', {
    staticClass: "menu-item",
    class: _vm.$route.meta.isIndex == true ? 'index' : ''
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('SETTING_LOGIN')) + "\n                    ")])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin && _vm.$route.meta.isLogin != true && _vm.showLogin),
      expression: "!isLogin && $route.meta.isLogin != true && showLogin"
    }]
  }, [_c('span', {
    staticClass: "custom-item",
    on: {
      "click": function($event) {
        _vm.login(3, 2)
      }
    }
  }, [_c('span', {
    staticClass: "menu-item",
    class: _vm.$route.meta.isIndex == true ? 'index' : ''
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('SETTING_SIGNUP')) + "\n                    ")])])]), _vm._v(" "), (_vm.isLogin) ? _c('li', [_c('div', {
    class: {
      'user-info': true, 'user-info-light': !_vm.$route.meta.isIndex
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover",
      "hide-timeout": 200,
      "show-timeout": 200
    }
  }, [_c('span', {
    staticClass: "custom-item el-dropdown-link",
    class: _vm.$route.meta.menuIndex == 'member' ? 'is-active' : '',
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-male"
  }), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(_vm.sysUserName.indexOf('@') != -1 ? _vm.sysUserName.split('@')[0] : _vm.sysUserName) + "\n                        ")])]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(false) ? _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.userDetail($event)
      }
    }
  }, [_c('span', {
    staticClass: "userinfo-inner",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": _vm.sysUserAvatar,
      "height": "30",
      "width": "30"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.sysUserName))])])]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/member/account')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle pd-lf15"
  }), _vm._v(" "), _c('span', {
    staticClass: "pd-lf30"
  }, [_vm._v(_vm._s(_vm.$t('_8A182451A9CE6F93')))])]), _vm._v(" "), (false) ? _c('el-dropdown-item', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/member/my-db')
      }
    }
  }, [_c('span', {
    staticClass: "DB-img"
  }), _vm._v(" "), _c('span', {
    staticClass: "pd-lf30"
  }, [_vm._v(_vm._s(_vm.$t('_CEC257C6291C92B6')))])]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/user_central/person')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart pd-lf15"
  }), _vm._v(" "), _c('span', {
    staticClass: "pd-lf30"
  }, [_vm._v(_vm._s(_vm.$t('D057')))])]), _vm._v(" "), _c('el-dropdown-item', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out pd-lf15"
  }), _vm._v(" "), _c('span', {
    staticClass: "pd-lf30"
  }, [_vm._v(_vm._s(_vm.$t('LOG_OUT')))])])], 1)], 1)], 1)]) : _vm._e()])])])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "page-container"
  }, [_c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "content-container",
    class: this.$route.meta.isPd ? 'pd' : ''
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    class: {
      bgf: _vm.$route.meta.bgcF
    },
    attrs: {
      "span": 24
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    attrs: {
      "getUserDone": _vm.getUserDone,
      "level": _vm.level,
      "max_level": _vm.max_level,
      "newBindContact": _vm.bindContactName
    },
    on: {
      "change-home-avatar": _vm.changeHomeAvatar,
      "setLogout": _vm.setLogout,
      "loGin": _vm.login,
      "get-user-info": _vm.getUser
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    attrs: {
      "getUserDone": _vm.getUserDone,
      "level": _vm.level,
      "max_level": _vm.max_level,
      "newBindContact": _vm.bindContactName,
      "channelColor": _vm.channelColor
    },
    on: {
      "change-home-avatar": _vm.changeHomeAvatar,
      "setLogout": _vm.setLogout,
      "loGin": _vm.login,
      "get-user-info": _vm.getUser
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.huisuanzhangFlag) ? _c('Feedback', {
    on: {
      "loGin": _vm.login
    }
  }) : _vm._e()], 1)], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "register-bg custom-register-form"
  }), _vm._v(" "), _c('loginForm', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "custom-register-form",
    attrs: {
      "showDialog": true,
      "formParams": _vm.formParams,
      "dialogTyper": _vm.dialogTyper,
      "nameTyper": _vm.nameTyper,
      "invitedIdGard": _vm.invitedIdGard,
      "isLimitOut": _vm.isLimitOut,
      "searchTip": _vm.searchTip
    },
    on: {
      "closeDialog": function($event) {
        _vm.dialogVisible = false;
      },
      "asycNameType": _vm.handleBindChange,
      "get-user-info": _vm.getUser,
      "synchronousVar": _vm.synVar
    }
  }), _vm._v(" "), (false) ? _c('footer', {
    staticClass: "page-footer",
    class: {
      'page-foot-fixed': _vm.footHome
    }
  }, [((_vm.isChannel || !_vm.showLogin) && !_vm.footHome) ? _c('span', [_vm._v(_vm._s(_vm.$t('D382')))]) : _vm._e(), _vm._v(" "), (_vm.footHome && !_vm.isChannel && _vm.showLogin) ? _c('p', [_vm._v(_vm._s(_vm.$t('D415')) + "：service@xieco.net")]) : _vm._e(), _vm._v(" "), (_vm.footHome && !_vm.isChannel && _vm.showLogin && _vm.isCN) ? _c('p', [_vm._v(_vm._s(_vm.$t('_C7286B64327DEBBB')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.footHome && !_vm.huisuanzhangFlag) ? _c('footerComp', {
    on: {
      "loGin": _vm.login
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTipFlag) ? _c('el-dialog', {
    staticClass: "index-tip-dialog",
    attrs: {
      "center": "",
      "visible": _vm.showTipFlag,
      "before-close": _vm.handleClose,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showTipFlag = $event
      }
    }
  }, [_c('span', {
    staticClass: "index-tip-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('D481')))]), _vm._v(" "), _c('ul', {
    staticClass: "index-tip"
  }, [_c('li', {
    staticClass: "item mag-t-20"
  }, [_vm._v(_vm._s(_vm.$t('D483')))]), _vm._v(" "), _c('li', {
    staticClass: "item mg-l-20"
  }, [_vm._v(_vm._s(_vm.$t('D484')))]), _vm._v(" "), _c('li', {
    staticClass: "item mg-l-20"
  }, [_vm._v(_vm._s(_vm.$t('D485')))]), _vm._v(" "), _c('li', {
    staticClass: "item mg-l-20"
  }, [_vm._v(_vm._s(_vm.$t('D486')))]), _vm._v(" "), _c('li', {
    staticClass: "item mag-b-20"
  }, [_vm._v(_vm._s(_vm.$t('D487')))]), _vm._v(" "), _c('li', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.$t('D488')))])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.$t('D489')))])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c9bac25"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 618
// module chunks = 39